import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function DesignerAccessPage() {
  const { token } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await api.post(`/branding/enter/${token}`);
        if (!cancelled) window.location.replace("/branding");
      } catch (e) {
        if (!cancelled) setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white px-6" data-testid="designer-access-page">
      <div className="max-w-sm text-center">
        {!error ? (
          <>
            <div className="w-10 h-10 border-2 border-[#00CCC9] border-t-transparent rounded-full animate-spin mx-auto mb-5" />
            <div className="text-xs font-bold uppercase tracking-overline text-white/60">Branding Studio</div>
            <div className="font-heading text-2xl font-light tracking-tighter mt-2">Zugang wird geprüft…</div>
          </>
        ) : (
          <>
            <div className="text-xs font-bold uppercase tracking-overline text-red-400">Zugang fehlgeschlagen</div>
            <div className="font-heading text-2xl font-light tracking-tighter mt-2" data-testid="designer-access-error">{error}</div>
            <p className="text-xs text-white/50 mt-4">Bitte wende dich an die Person, die dir diesen Link geschickt hat.</p>
          </>
        )}
      </div>
    </div>
  );
}
